import * as React from 'react';
import { SVGProps } from 'react';

const IconDocDeleteSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.01 4c0-1.1.89-2 1.99-2h7.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V20c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.01-16zM13 3.5V8a1 1 0 0 0 1 1h4.5L13 3.5zm-.3 12.314 1.414-1.414 1.414 1.414 1.415-1.414 1.414 1.414-1.414 1.415 1.414 1.414-1.414 1.414-1.415-1.414-1.414 1.414-1.414-1.414 1.414-1.415-1.414-1.414z"
    />
  </svg>
);
export default IconDocDeleteSizeM;
